import { render, staticRenderFns } from "./Module.vue?vue&type=template&id=57a41c0c&scoped=true&"
import script from "./Module.vue?vue&type=script&lang=tsx&"
export * from "./Module.vue?vue&type=script&lang=tsx&"
import style0 from "./Module.vue?vue&type=style&index=0&id=57a41c0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a41c0c",
  null
  
)

export default component.exports